import axios from 'axios';
import { API_CONTENT_URL, API_TIMEOUT } from '../config';

const client = axios.create({
    baseURL: API_CONTENT_URL,
    timeout: API_TIMEOUT,
    headers: { 'Content-Type': 'application/json' },
});


export const getPageBySlug = async (slug) => {
    try {
        const response = await client.get('/pages', {
            params: { slug },
        });
        return response.data[0] || null;
    } catch (error) {
        console.error(`[appService] Error fetching page "${slug}":`, error);
        throw error;
    }
};
